import React from "react"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from "@mui/material"
import { Formik } from "formik"
import i18n from "@/i18n"
import { useCreateUserValidationSchema } from "@/forms/create_user"
import UserFormFields from "./user_form_fields"

interface CreateUserDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: (values: any, helpers: any) => void
  creating: boolean
}

const CreateUserDialog: React.FC<CreateUserDialogProps> = ({ open, onClose, onSubmit, creating }) => {
  const validationSchema = useCreateUserValidationSchema()

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth data-testid="settings-users-create-dialog">
      <DialogTitle data-testid="settings-users-create-dialog-title">
        {i18n.t("app.settings.users.list.create_user")}
      </DialogTitle>
      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          passwordConfirmation: "",
          phone: "",
          position: "",
          country: "",
          address: "",
          city: "",
          postcode: "",
          roles: [],
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <DialogContent>
              <UserFormFields formik={formik} showPasswordFields />
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} color="primary" data-testid="settings-users-create-dialog-btn-cancel">
                {i18n.t("app.actions.cancel")}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={creating}
                data-testid="settings-users-create-dialog-btn-submit"
              >
                {creating ? <CircularProgress size={24} /> : i18n.t("app.settings.users.list.create_user")}
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  )
}

export default CreateUserDialog
